<template>
  <v-card style="position: relative">
    <v-card-text>
      <v-layout>
        <v-flex>
          <v-btn
            small
            class="mx-0"
            :color="toggleAll ? 'primary' : 'grey'"
            @click="handleToggleAll()"
          >
            <v-icon small class="mr-2">
              {{ toggleAll ? 'check_box' : 'check_box_outline_blank' }}
            </v-icon>
            เลือกทั้งหมด
          </v-btn>
        </v-flex>
        <v-flex class="text-xs-right">
          <v-btn
            small
            class="mx-0"
            color="primary"
            :disabled="selectedQuestions.length == 0"
            @click="handleAddToConversation()"
          >
            <v-icon small class="mr-2">add</v-icon>{{ $t('add') }}
          </v-btn>
        </v-flex>
      </v-layout>
      <div class="my-2">{{ intentLabel(conversation.intentname) }}</div>
      <v-divider :style="{ 'border-color': $vuetify.theme.primary }" />
      <div class="caption">Answers recommended</div>
      <div :class="{ 'show-more': showMoreAnswers, 'show-less': !showMoreAnswers }">
        <ul class="tags">
          <li
            v-for="(word, index) in conversation.questiondata_array"
            :key="'word_' + word.id + '_' + index"
            class="tag"
            :class="{ active: $store.state.selectedAutoTraining.includes(word.questiondata) }"
            style="margin-right: 5px; margin-bottom: 5px; cursor: pointer; text-align: left"
            :title="word.questiondata"
            @click="handleToggleQuestiondata(word)"
          >
            <span
              :class="{
                'fas fa-check-circle': $store.state.selectedAutoTraining.includes(
                  word.questiondata
                ),
                'far fa-circle': !$store.state.selectedAutoTraining.includes(word.questiondata)
              }"
            ></span>
            <div style="display: inline-block; vertical-align: middle; word-break: break-all">
              {{ word.questiondata }} {{ word.score | decimalFormat }}
            </div>
            <template v-if="word.count > 1">({{ word.count }})</template>
          </li>
        </ul>
      </div>

      <div class="text-xs-center">
        <v-btn small flat color="primary" @click="handleShowMoreAnswer">
          Show {{ !showMoreAnswers ? 'more' : 'less' }} answers
        </v-btn>
      </div>
    </v-card-text>
    <div style="position: relative">
      <v-divider style="position: absolute; top: 50%; left: 0; width: 100%" />
      <div style="text-align: center">
        <v-btn
          outline
          small
          color="grey"
          round
          style="background: white !important"
          @click="showChatbotAnswer = !showChatbotAnswer"
        >
          Chatbot answers
          <v-icon class="ml-1" small>{{
            showChatbotAnswer ? 'arrow_drop_up' : 'arrow_drop_down'
          }}</v-icon>
        </v-btn>
      </div>
    </div>
    <template v-if="showChatbotAnswer">
      <v-card-text>
        Chatbot answers

        <div class="my-2">
          <message-viewer :value="conversation.answers" />
        </div>
      </v-card-text>
    </template>

    <v-dialog v-model="showDialogAllowUseChatGpt" persistent max-width="800px">
      <v-card>
        <DialogAllowUseChatGptVue
          @onAllow="handleAllow"
          @onSkip="handleSkip"
          @onClose="showDialogAllowUseChatGpt = false"
        />
      </v-card>
    </v-dialog>

    <v-dialog v-model="showDialogSuggestWording" persistent max-width="800px" scrollable>
      <template v-if="showDialogSuggestWording">
        <DialogSuggestWordingVue
          :allow-use-chat-gpt="allowUseChatGpt"
          :selected-questions="selectedQuestions"
          @onCancel="showDialogSuggestWording = false"
          @onSave="handleAddToExistingConversation"
        />
      </template>
    </v-dialog>

    <template
      v-if="
        $store.state.selectConversationAutoTrainingID != conversation.intent_id &&
        $store.state.selectConversationAutoTrainingID != ''
      "
    >
      <div
        style="background: #ffffffb0; width: 100%; height: 100%; position: absolute; top: 0"
      ></div>
    </template>
  </v-card>
</template>

<script>
import MessageViewer from '@/components/elements/MessageViewer'
import DialogAllowUseChatGptVue from './DialogAllowUseChatGpt.vue'
import DialogSuggestWordingVue from './DialogSuggestWording.vue'
export default {
  components: {
    MessageViewer,
    DialogAllowUseChatGptVue,
    DialogSuggestWordingVue
  },
  props: ['conversation'],
  data() {
    return {
      showDialogAllowUseChatGpt: false,
      allowUseChatGpt: false,
      showChatbotAnswer: false,
      toggleAll: false,
      showMoreAnswers: false,
      showDialogSuggestWording: false,
      selectedQuestions: []
    }
  },
  mounted() {},
  methods: {
    handleAddToExistingConversation(payload) {
      const vm = this
      vm.$emit('onAddToConversation', {
        id: vm.conversation.intent_id,
        intentname: vm.conversation.intentname,
        words: payload.words,
        onSuccess: async () => {
          vm.showDialogSuggestWording = false
          const selected = vm.$store.state.selectedAutoTraining || []
          const filterDuplicate = selected.filter((item) => !payload.words.includes(item))
          vm.$store.commit('SET_SELECTED_AUTO_TRAINING', filterDuplicate)
          vm.selectedQuestions = []
          vm.$store.state.selectConversationAutoTrainingID = ''
          await vm.$swal({
            title: 'เพิ่มข้อมูลลงในบทสนทนาเรียบร้อยแล้ว',
            type: 'success'
          })
        },
        onError: () => {
          vm.$swal({
            title: 'Error',
            text: 'เกิดข้อผิดพลาดในการเพิ่มคำถาม',
            type: 'error'
          })
        }
      })
    },
    handleToggleQuestiondata(word) {
      const selected = this.$store.state.selectedAutoTraining || []
      if (this.selectedQuestions.includes(word.questiondata)) {
        this.selectedQuestions = this.selectedQuestions.filter((item) => item != word.questiondata)
      } else {
        this.selectedQuestions.push(word.questiondata)
      }
      if (selected.includes(word.questiondata)) {
        // deselect
        const filterDuplicate = selected.filter((item) => item != word.questiondata)
        this.$store.commit('SET_SELECTED_AUTO_TRAINING', filterDuplicate)
        if (this.selectedQuestions.length == 0) {
          this.$store.state.selectConversationAutoTrainingID = ''
        }
      } else {
        // select
        const filterDuplicate = [...new Set([...selected, word.questiondata])]
        this.$store.commit('SET_SELECTED_AUTO_TRAINING', filterDuplicate)
        this.$store.state.selectConversationAutoTrainingID = this.conversation.intent_id
      }
      this.handleCheckSelectAll()
    },
    handleCheckSelectAll() {
      const intersectQuestiondata = this.conversation.questiondata_array
        ? this.conversation.questiondata_array.filter((item) =>
            this.$store.state.selectedAutoTraining.includes(item.questiondata)
          )
        : []
      this.toggleAll =
        intersectQuestiondata &&
        this.conversation.questiondata_array &&
        intersectQuestiondata.length == this.conversation.questiondata_array.length
    },
    handleShowMoreAnswer() {
      this.showMoreAnswers = !this.showMoreAnswers
    },
    handleAllow() {
      this.showDialogAllowUseChatGpt = false
      this.allowUseChatGpt = true
      this.showDialogSuggestWording = true
    },
    handleSkip() {
      this.showDialogAllowUseChatGpt = false
      this.allowUseChatGpt = false
      this.showDialogSuggestWording = true
    },
    handleToggleAll() {
      const selected = this.$store.state.selectedAutoTraining || []

      if (this.toggleAll) {
        // deselect all
        const questiondata =
          this.conversation.questiondata_array.map((item) => item.questiondata) || []
        const filterDuplicate =
          selected && selected.length > 0
            ? selected.filter((item) => !questiondata.includes(item))
            : []
        this.selectedQuestions = []
        this.toggleAll = false
        this.$store.commit('SET_SELECTED_AUTO_TRAINING', filterDuplicate)
        this.$store.state.selectConversationAutoTrainingID = ''
      } else {
        // select all
        const filterDuplicate = [
          ...new Set([
            ...selected,
            ...(this.conversation.questiondata_array
              ? this.conversation.questiondata_array.map((item) => item.questiondata)
              : [])
          ])
        ]
        this.selectedQuestions = this.conversation.questiondata_array.map(
          (item) => item.questiondata
        )
        this.toggleAll = true
        this.$store.commit('SET_SELECTED_AUTO_TRAINING', filterDuplicate)
        this.$store.state.selectConversationAutoTrainingID = this.conversation.intent_id
      }
    },
    async handleAddToConversation() {
      const selectedInItems = this.conversation.questiondata_array
        ? this.conversation.questiondata_array.filter((item) =>
            this.$store.state.selectedAutoTraining.includes(item.questiondata)
          )
        : []
      if (selectedInItems.length == 0) {
        await this.$swal({
          title: 'ไม่พบข้อมูล',
          text: 'กรุณาเลือกคำถามที่ต้องการเพิ่ม',
          type: 'warning'
        })
      } else {
        this.selectedQuestions = selectedInItems
        this.showDialogAllowUseChatGpt = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.show-more {
  height: auto;
  overflow: auto;
}
.show-less {
  position: relative;
  max-height: 100px;
  overflow: hidden;

  &::after {
    content: '';
    width: 100%;
    height: 20%;
    position: absolute;
    left: 0;
    bottom: 0;
    background: linear-gradient(transparent 10px, white);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/intent/Training/AutoTrainingItem.vue